import { clsx } from 'clsx';
import type { MaterialSymbol } from 'material-symbols';
import type { HTMLAttributes, ReactNode } from 'react';
import { ForwardedRef, forwardRef } from 'react';

export type IconTypes = MaterialSymbol;

export interface IconProps extends HTMLAttributes<HTMLSpanElement> {
    fontSize?: 'small' | 'medium' | 'normal' | 'large';
    name: IconTypes;
}

function IconComponent(
    { id, fontSize = 'small', className, name, color, ...rest }: IconProps,
    ref: ForwardedRef<HTMLSpanElement>,
): ReactNode {
    const classNames = clsx(
        'guardian-icon',
        'guardian-icon--' + fontSize,
        className,
    );

    return (
        <span
            ref={ref}
            id={id}
            style={{ color }}
            className={classNames}
            {...rest}
        >
            {name}
        </span>
    );
}

export const Icon = forwardRef(IconComponent);
